import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { SDK_CHROME } from "../../config/Constants";
import LoadingOverlay from "react-loading-overlay";

export default class AdvanceOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "Future orders",
      printSdkType: "",
      bookingDateSelected: false,
      spinnerLoading: false,
      grandTotal:0.0
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }
  componentDidMount() {
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
    this.getOrders();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  handleStartDateChange = date => {
    if ( Date.parse(this.state.endDate.format("MM/DD/YYYY")) < Date.parse(date.format("MM/DD/YYYY"))) 
    {
      alert("End date should be greater than Start date");
    }
    else {
      this.setState({
        startDate: date
      });
      console.log("startDate", this.state.startDate);
  }
  };
  handleBookingStartDateChange = date => {
    this.setState({
      bookingStartDate: date
    });
    console.log("startDate", this.state.startDate);
  };
  handleBookingEndDateChange = date => {
    if (
      Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          bookingEndDate: date
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("bookingEndDate 2" + date);
      this.setState({
        bookingEndDate: date
      });
    }
  };
  handleEndDateChange = date => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("endDate 2" + date);
      this.setState({
        endDate: date
      });
    }
  };

  getOrders = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }

    let date = "";
    let enddate = "";
    // currently configured only to work for IST
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date + "00:00:00-05:30";
      params.pushedAt_Gte = date;
      enddate = this.state.endDate.format("YYYY-MM-DDT");
      enddate = enddate + "23:59:00-05:30";
      params.pushedAt_Lte = enddate;
    }
  
    console.log("params", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getAdvanceOrders",
      params
    );

    if (response.error === null) {
      let grandTotal = 0.0;
      for (let i = 0; i < response.data.orderHistory.edges.length; i++) {
        grandTotal =
          grandTotal +
          response.data.orderHistory.edges[i].node.cart.settlementPrice;
      }

      this.setState({
        spinnerLoading: false,
        orders: response.data.orderHistory.edges,
        grandTotal: grandTotal.toFixed(2)
      });
    } else {
      this.setState({ spinnerLoading: false });
    }

    console.log(response);
  };

  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let startdate = "",
      enddate = "";

    if (this.state.bookingDateSelected === false) {
      startdate = this.state.startDate.format("YYYY-MM-DD");
      enddate = this.state.endDate.format("YYYY-MM-DD");
    } else {
      startdate = this.state.bookingStartDate.format("YYYY-MM-DD");
      enddate = this.state.bookingEndDate.format("YYYY-MM-DD");
    }

    let csvData = [
      [this.state.pageText],
      ["Grand Total", "Start Date", "End Date"],
      [this.state.grandTotal, startdate, enddate],
      [""],
      [""],
      ["Order Id", "Token", "Status", "Date/Time", "Amount", "Store"]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.pushedAt).format("MMMM Do YYYY, h:mm a"),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name
      ]);
    });
    // eslint-disable-next-line
    return csvData;
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Modal
            isOpen={this.state.orderModalVisible}
            toggle={this.toggleModal}
            size="lg"
          >
            <DetailedOrderCard
              editable={true}
              order={this.state.selectedOrder}
              toltalItemCount={null}
              goBack={this.toggleModal}
              refreshOrders={() => { }}
              pastOrder={true}
              storeInformation={this.state.storeInformation}
            />
          </Modal>

          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Grand Total= " + this.state.grandTotal}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <div
                        style={{
                          justifyContent: "space-between"
                        }}
                      >
                        <p> Calender Date</p>
                        <div>
                          <Col>Start Date</Col>
                          <Col>
                          <div>
                          <DatePicker
                            selected={this.state.startDate}
                            maxDate={moment().add(30, "days").endOf("day")}
                            dateFormat="DD/MM/YYYY"
                            id="input"
                            readonly
                            onChange={this.handleStartDateChange}
                          />
                          </div>
                          </Col>
                          <Col>End Date</Col>
                          <Col>
                          <div style={{ marginTop: 15, marginBottom: 15 }}>
                            <DatePicker
                              selected={this.state.endDate}
                              dateFormat="DD/MM/YYYY"
                              id="input"
                              disabledKeyboardNavigation={true}
                              maxDate={moment().add(30, "days").endOf("day")}
                              onChange={this.handleEndDateChange}
                            />
                          </div> 
                          </Col>
                        </div>
                        <Button
                          style={{ marginLeft: 20 }}
                          onClick={() => {
                            // this.setState({"bookingDateSelected": false})
                            this.getOrders();
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    </Row>
                  </Container>
                </CardHeader>
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>status</th>
                      <th>Date/Time</th>
                      <th>Amount</th>
                      <th>Store</th>
                    </tr>
                    {this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                          onClick={() => {
                            this.setState({ selectedOrder: order });
                            this.toggleModal();
                          }}
                        >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td>{order.node.status}</td>
                          <td>
                            {moment(order.node.pushedAt).format(
                              "MMMM Do YYYY, h:mm a"
                            )}
                          </td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AdvanceOrders/AdvanceOrders.jsx